import { fetchCatalogService } from "@common/hooks/serviceCatalog";

const getService = ({ account, serviceId, approved = false }) =>
  fetchCatalogService({
    accessToken: account.authorizationCode,
    approved,
    id: serviceId,
    include: [
      "subservices",
      "resource",
      "phase",
      "subservices.resource",
      "subservices.service",
      "service-category",
      "products",
    ],
  });

export default getService;
